import React from 'react';

interface PageHeaderProps {
  icon: React.ElementType;
  iconBg: string;
  iconColor: string;
  title: string;
  description: string;
  action?: React.ReactNode;
}

export function PageHeader({
  icon: Icon,
  iconBg,
  iconColor,
  title,
  description,
  action
}: PageHeaderProps) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className={`w-14 h-14 ${iconBg} rounded-xl flex items-center justify-center`}>
            <Icon className={`w-7 h-7 ${iconColor}`} />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
            <p className="text-slate-500">{description}</p>
          </div>
        </div>
        {action}
      </div>
    </div>
  );
}
